import cls from "classnames";

import { pageview } from "@qoohoo/common/constants/analytics";
import FAQ from "components/FAQ";
import TranslateAppear from "components/Animation/TranslateAppear";

const FAQSection = ({
  items, heading, theme
}) => {
  const trackingDetails = {
    current_screen: pageview.product_page_telegram,
  };

  return (
    <section
      className={cls(
        "px-5 py-[60px] md:py-14 sm:px-20 font-nunito max-w-[1120px] mx-auto lg:px-0",
      )}
      style={{color: theme.textColor, backgroundColor: theme.backgroundColor }}
    >
      <TranslateAppear>
        <h2 className="w-full text-2xl leading-normal font-bold text-center md:text-[2.5rem]">
          {heading}
        </h2>
      </TranslateAppear>
      <div className="text-[#DBDBDB] mt-9 md:mt-14 space-y-3 md:space-y-6 w-full md:flex md:flex-col items-center justify-center">
        <FAQ
          faqs={items}
          isLightMode={!theme.isDark}
          faqQuestionBackground={theme.faq.questionBackgroundColor}
          faqAnswerBackground={theme.faq.answerBackgroundColor}
          {...trackingDetails}
        />
      </div>
    </section>
  );
};

export default FAQSection;